import axios from 'axios';

const API_URL = process.env.VUE_APP_ROOT_API;

class AuthService {
  login(user: any) {
    return axios
      .post('signin', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        return response.data;
      });
  }

  logout() {
    return axios.post('signout')
  }

  register(user: any) {
    return axios.post(API_URL + 'api/signup', {
      phone: user.phone,
      email: user.email,
      password: user.password,
      password_confirmation: user.password,
      firstName: user.firstName,
      lastName: user.lastName,
      cityID: user.city,
      storeType: user.storeType,
      storeName: "********",
    });
  }


}

export default new AuthService();
